import api from './api';
import authApi from './authApi';

class AuthService {

    async login(credentials) {
        const response = await authApi.post(
            '/auth/login',
            credentials
        );

        return response.data;
    }

    async register(userData) {
        const response = await authApi.post(
            '/auth/register',
            userData
        );

        return response.data;
    }

    async refresh(refreshToken) {
        const response = await authApi.post(
            '/auth/refresh',
            null,
            {
                headers: {
                    Authorization: `Bearer ${refreshToken}`,
                },
            }
        );

        return response.data;
    }

    async me() {
        // Va por `api` (no por `authApi`): así, si el access_token ha
        // caducado, el interceptor lo renueva solo y reintenta esta
        // petición, en vez de fallar directamente.
        const response = await api.get('/auth/me');

        return response.data;
    }
}

export default new AuthService();